import { ProtocoloEntidade } from "../../../entidades/ProtocoloEntidade";
import { Alerta, Box, Botao, CampoEstatico, TipoBotao, TipoAlerta } from "@intechprev/componentes-web";
import { ComprovantesService } from "../../../services/ComprovantesService";
import moment from "moment";
import React from "react";
import { MasterPage, NumFuncionalidade } from "../../MasterPage";
import { reCAPTCHA } from "../../../helpers";

interface Props {
  history?: any;
  match?: any;
}

interface State {
  comprovante: ProtocoloEntidade;
  erro: string;
  loading: boolean;
}

export class ComprovanteDetalhe extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("comprovantes_detalhe");

  private page = React.createRef<MasterPage>();

  constructor(props: Props) {
    super(props);

    this.state = {
      comprovante: null,
      erro: "",
      loading: false,
    };
  }

  componentDidMount = async () => {
    await this.setState({ loading: true });

    try {
      let comprovante = await ComprovantesService.BuscarPorOid(this.props.match.params.oid);
      await this.setState({ comprovante });
    } catch (err) {
      await this.setState({ erro: err.response ? err.response.data : err });
    } finally {
      await this.setState({ loading: false });
    }
  };

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.COMPROVANTES} ref={this.page} {...this.props}>
        <Botao tipo={TipoBotao.primary} className="mb-3" titulo="Voltar" onClick={() => this.props.history.goBack()} />

        {!this.state.loading && this.state.erro && <Alerta tipo={TipoAlerta.danger}>{this.state.erro}</Alerta>}

        {!this.state.loading && !this.state.erro && this.state.comprovante && (
          <>
            <Box titulo={"Dados do Participante / Pensionista"}>
              <CampoEstatico titulo="Nome" valor={this.state.comprovante.NOME_ENTID} tamanhoTitulo={"lg-3"} />
              <CampoEstatico
                titulo="Plano"
                valor={this.state.comprovante.DS_PLANO ? this.state.comprovante.DS_PLANO : "TODOS"}
                tamanhoTitulo={"lg-3"}
              />
            </Box>

            <Box titulo="Dados da Transação">
              <CampoEstatico titulo="Nome da Transação" valor={this.state.comprovante.DES_FUNCIONALIDADE} tamanhoTitulo={"lg-3"} />
              <CampoEstatico titulo="Número de Protocolo" valor={this.state.comprovante.COD_IDENTIFICADOR} tamanhoTitulo={"lg-3"} />
              <CampoEstatico
                titulo="Data da Solicitação"
                valor={moment(this.state.comprovante.DTA_SOLICITACAO, "DD/MM/YYYY hh:mm:ss").format("DD/MM/YYYY hh:mm:ss")}
                tamanhoTitulo={"lg-3"}
              />
              <CampoEstatico titulo="Solicitado por" valor={this.state.comprovante.TXT_USUARIO_SOLICITACAO} tamanhoTitulo={"lg-3"} />
              <CampoEstatico
                titulo="Data da Efetivação"
                valor={
                  this.state.comprovante.DTA_EFETIVACAO
                    ? moment(this.state.comprovante.DTA_EFETIVACAO, "DD/MM/YYYY hh:mm:ss").format("DD/MM/YYYY hh:mm:ss")
                    : "-"
                }
                tamanhoTitulo={"lg-3"}
              />
              <CampoEstatico
                titulo="Efetivado por"
                valor={this.state.comprovante.TXT_USUARIO_EFETIVACAO ? this.state.comprovante.TXT_USUARIO_EFETIVACAO : "-"}
                tamanhoTitulo={"lg-3"}
              />
              <CampoEstatico titulo="Motivo da Recusa" valor={this.state.comprovante.TXT_MOTIVO_RECUSA} tamanhoTitulo={"lg-3"} />
            </Box>

            <Box titulo="Conteúdo da Transação">
              {this.state.comprovante.ListaTransacao.map((itemTransacao, index) => (
                <CampoEstatico key={index} titulo={itemTransacao.Titulo} valor={itemTransacao.Valor} tamanhoTitulo={"lg-3"} />
              ))}
            </Box>

            <Box titulo="Dados Técnicos">
              <CampoEstatico titulo="Endereço IPV4 Local" valor={this.state.comprovante.TXT_IPV4} tamanhoTitulo={"lg-3"} />
              <CampoEstatico titulo="Endereço IPV4 Externo" valor={this.state.comprovante.TXT_IPV4_EXTERNO} tamanhoTitulo={"lg-3"} />
              <CampoEstatico titulo="Endereço IPV6" valor={this.state.comprovante.TXT_IPV6} tamanhoTitulo={"lg-3"} />
              <CampoEstatico titulo="Dispositivo" valor={this.state.comprovante.TXT_DISPOSITIVO} tamanhoTitulo={"lg-3"} />
              <CampoEstatico titulo="Origem" valor={this.state.comprovante.TXT_ORIGEM} tamanhoTitulo={"lg-3"} />
            </Box>
          </>
        )}
      </MasterPage>
    );
  }
}
